module.exports = __webpack_public_path__ + "assets/img/warrior-name-e8929039.png";